module.exports = __webpack_public_path__ + "img/aoffx-gl7s6.5f92e916.png";